export default __webpack_public_path__ + "static/media/woodbine.fd02cbd3.jpg";